import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { getAllTaskSelect } from '../api';
export function getMyReviewDefaultForm() {
  return {
    number: '',
    item_number: '',
    user_id: '',
    customer_id: null,
    project_name: '',
    project_type: [],
    type: [],
    expedited_not: null,
    urgent_printing: null,
    pageSize: 20,
    page: 1
  };
}
export function getQuotationDefaultForm(page) {
  var base = {
    number: '',
    user_id: '',
    customer_id: null,
    project_name: '',
    pageSize: 20,
    page: 1
  };
  if (page === 'myToDo') {
    return _objectSpread(_objectSpread({}, base), {}, {
      item_number: '',
      status: [100],
      project_type: [],
      created_start: '',
      created_end: ''
    });
  }
  if (page === 'allToDo') {
    return _objectSpread(_objectSpread({}, base), {}, {
      item_number: '',
      status: [100],
      project_type: [],
      task_person_charge_id: null,
      created_start: '',
      created_end: ''
    });
  }
  return base;
}
export function getMyToDoDefaultStatus(tabName) {
  if (tabName === '1') return [100, 200];
  if (tabName === '3') return [100, 300, 450, 550];
  return [100];
}
export function getMyToDoDefaultForm(tabKey) {
  var tabMap = {
    project: '1',
    mall: '2',
    bidding: '3',
    card: '4'
  };
  var tabName = tabMap[tabKey] || '1';
  return {
    number: '',
    item_number: '',
    user_id: null,
    status: getMyToDoDefaultStatus(tabName).slice(),
    type_of_demand: [],
    need_printing: null,
    customer_id: null,
    project_name: '',
    project_type: [],
    type: [],
    person_charge_id: [],
    task_person_charge_id: null,
    bid_files: null,
    created_start: '',
    created_end: '',
    estimated_amount_start: '',
    estimated_amount_end: '',
    card_make: [],
    card_make_print: [],
    design_complexity: [],
    pageSize: 20,
    page: 1
  };
}
export function getAllToDoDefaultStatus(tabName) {
  var taskStatusOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (tabName === '1') return [100, 200];
  if (tabName === '2') {
    return taskStatusOptions.filter(function (item) {
      return item.checked;
    }).map(function (item) {
      return item.value;
    });
  }
  if (tabName === '4') return [100, 300, 450, 550];
  return [100];
}
export function getAllToDoDefaultForm(tabKey) {
  var taskStatusOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var tabMap = {
    project: '1',
    task: '2',
    mall: '3',
    bidding: '4',
    card: '5'
  };
  var tabName = tabMap[tabKey] || '1';
  return {
    number: '',
    item_number: '',
    user_id: null,
    status: getAllToDoDefaultStatus(tabName, taskStatusOptions).slice(),
    type_of_demand: [],
    need_printing: null,
    customer_id: null,
    project_name: '',
    project_type: [],
    type: [],
    person_charge_id: [],
    task_person_charge_id: null,
    bid_files: null,
    created_start: '',
    created_end: '',
    estimated_amount_start: '',
    estimated_amount_end: '',
    card_make: [],
    card_make_print: [],
    design_complexity: [],
    pageSize: 20,
    page: 1
  };
}

// 印刷工单（全部待办 tab=8 / printWorkOrder.vue）搜索表单默认值，
// 字段与 printWorkOrder.vue 列表搜索保持一致，供 all-to-do 计数接口 card_make_print 参数使用
export function getCardMakePrintDefaultForm() {
  return {
    print_type: '',
    // 印刷类型
    material_type: '',
    // 物料类型
    supplier_id: '',
    // 供应商
    make_status: '0',
    // 制作状态
    settlement_status: '',
    // 结算状态
    city: [],
    // 印刷城市
    status: '1',
    // 有效/无效
    id: '',
    // 印刷单ID
    batch: '',
    // 卡批次号
    customer_id: '',
    // 客户id
    order_id: '',
    // 订单id
    user_id: '',
    // 销售负责人
    is_urgent: '',
    // 是否加急 1:是 0:否
    start_num: '',
    // 设计稿数起始
    end_num: '',
    // 设计稿数结束
    project_delivery_number: '',
    // 设计工单ID
    card_make_status: [],
    // 制卡状态
    create_time: [],
    // 创建时间
    is_project_delivery: 1,
    // 项目交付入口固定携带
    page: 1
  };
}
export function getTicketDefaultForm(page) {
  return {
    work_order_no: '',
    title: '',
    second_category_id: [],
    item: '',
    status: page === 'myToDo' || page === 'allToDo' ? [20] : [],
    start_created_at: '',
    end_created_at: '',
    handler_id: page === 'allToDo' ? null : undefined,
    pageSize: 20,
    page: 1
  };
}
var taskStatusOptionsPromise = null;
export function getTaskStatusOptionsCached() {
  if (!taskStatusOptionsPromise) {
    taskStatusOptionsPromise = getAllTaskSelect().then(function (res) {
      var list = res.data || [];
      return Array.isArray(list) ? list : [];
    }).catch(function (err) {
      taskStatusOptionsPromise = null;
      throw err;
    });
  }
  return taskStatusOptionsPromise;
}

// 审批人展示格式（需求：初审：张三（待审批））
// approver 数组记录的节点/状态是裸字段（type 1=初审（原总经理） 2=复审（原VP），status 1=当前待审批节点），
// 部分列表会把审批人平铺到行上（approver_type/approver_name），两种命名都兼容
var APPROVER_NODE_TEXT = {
  1: '初审',
  2: '复审'
};
// status=0 表示流程未走到该节点，后端未给展示文案，先不加状态后缀
var APPROVER_STATUS_TEXT = {
  1: '待审批'
};
export function formatApprover(item) {
  if (!item) return '';
  var name = item.approver_name || item.name || '';
  var nodeType = item.approver_type != null ? item.approver_type : item.type;
  var node = APPROVER_NODE_TEXT[Number(nodeType)] || '';
  if (!node) return name;
  var statusValue = item.approver_status != null ? item.approver_status : item.status;
  var status = APPROVER_STATUS_TEXT[Number(statusValue)] || '';
  return "".concat(node, "\uFF1A").concat(name).concat(status ? "\uFF08".concat(status, "\uFF09") : '');
}